import React, { forwardRef, useEffect, useState, useRef } from "react";

import EventNotes from "../EventNotes";
import { createGuidId } from "../../../utils/teams-dragger";
import Header from "../Header";
import ChangeEventType from "../ChangeEventType";
import SelectChangePlayers from "../SelectChangePlayers";
import TypeOfEventType from "../TypeOfEventType";
import ConfirmButton from "../ConfirmButton";
import Submit from "./../HandleSubmit";
import SelectShootoutGoalkeeper from "../SelectShootoutGoalkeeper";
import PsPcButtons from "../PenaltyEvent/PsPcGoalMissButtons";
import isEventValidForSubmit from "../helpers/isEventValidForSubmit";

const formatData = (params) => {
    const {
        eventsToShow,
        matchId,
        matchData,
        setMatchData,
        formatApiData,
        homePlayers,
        awayPlayers,
        sides,
        setEventsToShow,
    } = params;
    const { quarter4, matchHasShootout, matchPosts } = matchData;
    const penaltyEvent = matchPosts?.some(
        (post) => post.additionalData === "Start of a shootout"
    );
    const isShootout = quarter4 && matchHasShootout && penaltyEvent;
    const event = eventsToShow[eventsToShow.length - 1];
    const comment = event?.eventNotes ? event?.eventNotes.trim() : null;
    const teamId = event.sideSelected.id;
    const playerId = event.playerSelected?.id;
    const goalkeeperId = event?.goalkeeperSelected?.id;
    const timestamp = event.timestamp;
    const minute = Math.ceil(timestamp / 60);
    let homeGoals = "";
    let awayGoals = "";
    if (goalkeeperId && isShootout) {
        homeGoals = matchData.homeGoals;
        awayGoals = matchData.awayGoals;
    } else {
        homeGoals =
            event.sideSelected.side === "home" &&
            event.typeOfGoal?.id !== 16 &&
            event.typeOfGoal?.id !== 28
                ? matchData.homeGoals + 1
                : matchData.homeGoals;
        awayGoals =
            event.sideSelected.side === "away" &&
            event.typeOfGoal?.id !== 16 &&
            event.typeOfGoal?.id !== 28
                ? matchData.awayGoals + 1
                : matchData.awayGoals;
    }
    const orderIndex = matchData.matchPosts.length;

    let quarter = "";
    switch (event.quarterSelected) {
        case "Q1":
            quarter = 1;
            break;
        case "Q2":
            quarter = 2;
            break;
        case "Q3":
            quarter = 3;
            break;
        case "Q4":
            quarter = 4;
            break;
        case "SO":
            quarter = 0;
            break;
    }

    const goalType = event.typeOfEventTypeSelected.id;
    let postType = "";
    let type = "";
    switch (goalType) {
        case 0:
            postType = 9;
            type = "Goals";
            break;
        case 1:
            postType = event.typeOfGoal.id;
            type = event.typeOfGoal.id === 18 ? "Goals" : "Penalty Corner";
            break;
        case 2:
            postType = event.typeOfGoal.id;
            type = event.typeOfGoal.id === 19 ? "Goals" : "7m";
            break;
        case 4:
            postType = event.typeOfGoal.id;
            type = event.typeOfGoal.id === 18 ? "Goals" : "Penalty Corner";
            break;
        case 32:
            postType = 32;
            type = "Penalty Shootout";
            break;
    }
    const goalEvent = {
        type,
        postType,
        match: matchId,
        team: teamId,
        player: isShootout ? goalkeeperId : playerId,
        minute,
        orderIndex,
        quarter: quarter,
        isLive: true,
        homeGoals,
        awayGoals,
        ...(isShootout ? { shooter: playerId } : {}),
        ...(comment ? { additionalData: comment } : {}),
    };

    const update = {
        homeGoals,
        awayGoals,
        matchPosts: [...matchData.matchPosts, goalEvent],
    };

    Submit(matchId, matchData, update, setMatchData)
        .then((data) =>
            formatApiData(
                data,
                sides,
                setEventsToShow,
                ...homePlayers,
                ...awayPlayers
            )
        )
        .catch((e) => console.error(e.message));
};

const AddGoalEvent = forwardRef(
    (
        {
            setIsModalOpen,
            EVENT_TYPES,
            setEventsToShow,
            GOAL_TYPES,
            eventDetailsToAdd,
            setEventDetailsToAdd,
            setSides,
            goals,
            setGoals,
            isEditing,
            setIsEditing,
            eventsToShow,
            matchId,
            matchData,
            setMatchData,
            formatApiData,
            homePlayers,
            awayPlayers,
            sides,
        },
        ref
    ) => {
        const isFirstRun = useRef(true);
        const initialEvent = useRef(eventDetailsToAdd);
        useEffect(() => {
            if (isFirstRun.current) {
                isFirstRun.current = false;
                return;
            }

            const event = eventsToShow[eventsToShow.length - 1];
            if (isEventValidForSubmit(event)) {
                formatData({
                    eventsToShow,
                    matchId,
                    matchData,
                    setMatchData,
                    formatApiData,
                    homePlayers,
                    awayPlayers,
                    sides,
                    setEventsToShow,
                });
            }
        }, [eventsToShow]);
        const [step, setStep] = useState("0,1");

        const showDoneButton =
            (eventDetailsToAdd?.playerSelected ||
                eventDetailsToAdd?.playerSelected === false) &&
            eventDetailsToAdd?.typeOfEventTypeSelected &&
            eventDetailsToAdd?.type &&
            eventDetailsToAdd?.sideSelected &&
            eventDetailsToAdd?.sideNotSelected;

        const { quarter4, matchHasShootout, matchPosts } = matchData;
        const penaltyEvent = matchPosts?.some(
            (post) => post.additionalData === "Start of a shootout"
        );
        const isShootout = quarter4 && matchHasShootout && penaltyEvent;
        const psEventActive = matchData.matchPosts?.length
            ? matchData.matchPosts[matchData.matchPosts.length - 1].postType ===
              14
            : false;
        const pcEventActive = matchData.matchPosts?.length
            ? matchData.matchPosts[matchData.matchPosts.length - 1].postType ===
              26
            : false;
        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "#E5E5E5",
                }}
            >
                <Header
                    eventDetails={eventDetailsToAdd}
                    setEventDetails={setEventDetailsToAdd}
                    setModalOpen={setIsModalOpen}
                    setSides={setSides}
                    goals={goals}
                    setGoals={setGoals}
                    isEditing={isEditing}
                    matchData={matchData}
                    isShootout={isShootout}
                    pcEventActive={pcEventActive}
                    psEventActive={psEventActive}
                />
                {[
                    "0",
                    "0,1",
                    "0,1,2",
                    "0,1,2,2.5",
                    "0,1,2,3",
                    "0,1,2,2.5,4",
                    "0,1,2,3,4",
                ].includes(step) && !isShootout ? (
                    <ChangeEventType
                        EVENT_TYPES={EVENT_TYPES}
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        changeCallback={() => {
                            setStep("0");
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                type: null,
                                playerSelected: null,
                                playerOpponentSelected: null,
                                typeOfEventTypeSelected: null,
                            }));
                        }}
                        confirmCallback={() => {
                            setStep("0,1");
                        }}
                    />
                ) : null}
                {["0,1", "0,1,2", "0,1,2,3", "0,1,2,3,4"].includes(step) && (
                    <SelectChangePlayers
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        isShootout={isShootout}
                        initialEvent={initialEvent}
                        changeCallback={() => {
                            setStep("0,1,2");
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                playerSelected: null,
                                typeOfEventTypeSelected: null,
                            }));
                        }}
                        confirmCallback={() => {
                            setStep("0,1,2,3");
                        }}
                        skipCallback={() => {
                            setStep("0,1,2,2.5");
                        }}
                    />
                )}
                {["0,1,2,2.5", "0,1,2,3", "0,1,2,2.5,4", "0,1,2,3,4"].includes(
                    step
                ) && !isShootout ? (
                    <TypeOfEventType
                        GOAL_TYPES={GOAL_TYPES}
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        psEventActive={psEventActive}
                        pcEventActive={pcEventActive}
                        changeCallback={() => {
                            setStep((data) =>
                                data?.split(",").slice(0, -1).join(",")
                            ); // this is necessary to remeber the step user selected of selection of players
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                typeOfEventTypeSelected: null,
                            }));
                        }}
                        confirmCallback={() => {
                            setStep((data) => data + ",4"); // this is necessary to remeber the step user selected of selection of players
                        }}
                    />
                ) : null}
                {["0,1,2,2.5", "0,1,2,3", "0,1,2,2.5,4", "0,1,2,3,4"].includes(
                    step
                ) &&
                (psEventActive || pcEventActive) ? (
                    <PsPcButtons
                        psEventActive={psEventActive}
                        pcEventActive={pcEventActive}
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        confirmCallback={() => {
                            setStep((data) => data + ",4"); // this is necessary to remeber the step user selected of selection of players
                        }}
                        changeCallback={() => {
                            setStep((data) =>
                                data?.split(",").slice(0, -1).join(",")
                            ); // this is necessary to remeber the step user selected of selection of players
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                typeOfGoal: null,
                            }));
                        }}
                    />
                ) : null}
                {["0,1,2,2.5", "0,1,2,3", "0,1,2,2.5,4", "0,1,2,3,4"].includes(
                    step
                ) && isShootout ? (
                    <SelectShootoutGoalkeeper
                        players={eventDetailsToAdd?.sideNotSelected?.players?.filter(
                            (player) =>
                                player?.isGoalkeeper ||
                                player?.isSubstituteGoalkeeper
                        )}
                        eventDetails={eventDetailsToAdd}
                        setEventDetails={setEventDetailsToAdd}
                        changeCallback={() => {
                            setStep((data) =>
                                data?.split(",").slice(0, -1).join(",")
                            ); // this is necessary to remeber the step user selected of selection of players
                            setEventDetailsToAdd((data) => ({
                                ...data,
                                goalkeeperSelected: null,
                                typeOfEventTypeSelected: null,
                            }));
                        }}
                        confirmCallback={() => {
                            setStep((data) => data + ",4"); // this is necessary to remeber the step user selected of selection of players
                        }}
                    />
                ) : null}
                {["0,1,2,2.5,4", "0,1,2,3,4"].includes(step) && (
                    <>
                        <EventNotes
                            textAreaValue={eventDetailsToAdd?.eventNotes}
                            showConfirmCancelButtons={
                                !!eventDetailsToAdd?.eventNotes?.length
                            }
                            confirmButtonAction={() => {}}
                            cancelButtonAction={() => {
                                setEventDetailsToAdd((data) => ({
                                    ...data,
                                    eventNotes: "",
                                }));
                            }}
                            onChange={(e) => {
                                setEventDetailsToAdd((data) => ({
                                    ...data,
                                    eventNotes: e.target.value,
                                }));
                            }}
                        />
                        {showDoneButton && (
                            <ConfirmButton
                                action={() => {
                                    const selectedSideName =
                                        eventDetailsToAdd[
                                            eventDetailsToAdd?.sideSelected
                                                ?.side
                                        ].side;
                                    if (
                                        eventDetailsToAdd?.typeOfGoal?.id ===
                                            19 ||
                                        eventDetailsToAdd?.typeOfGoal?.id === 18
                                    ) {
                                        setGoals((goals) => {
                                            const newGoals = {
                                                ...goals,
                                                [selectedSideName]:
                                                    goals[selectedSideName] + 1,
                                            };

                                            return newGoals;
                                        });
                                    }
                                    setEventsToShow((data) => {
                                        return [
                                            ...data,
                                            {
                                                id: createGuidId(),
                                                ...eventDetailsToAdd,
                                                ...(pcEventActive
                                                    ? {
                                                          typeOfCornerGoalSelected: true,
                                                      }
                                                    : {}),
                                                ...((eventDetailsToAdd
                                                    ?.typeOfGoal?.id === 19 ||
                                                    eventDetailsToAdd
                                                        ?.typeOfGoal?.id ===
                                                        18) && {
                                                    [selectedSideName]: {
                                                        ...eventDetailsToAdd[
                                                            selectedSideName
                                                        ],
                                                        goals:
                                                            eventDetailsToAdd[
                                                                selectedSideName
                                                            ].goals + 1,
                                                    },
                                                }),
                                                ...(isShootout
                                                    ? { penaltyShoot: true }
                                                    : {}),
                                            },
                                        ];
                                    });
                                    if (psEventActive || pcEventActive) {
                                        if (
                                            eventDetailsToAdd?.typeOfGoal
                                                ?.id !== 16
                                        ) {
                                            setEventDetailsToAdd((data) => {
                                                const {
                                                    sideSelected,
                                                    ...rest
                                                } = data;
                                                const selectedSide =
                                                    sideSelected.side;

                                                return {
                                                    ...rest,
                                                    [selectedSide]: {
                                                        ...data[selectedSide],
                                                        goals:
                                                            data[selectedSide]
                                                                .goals + 1,
                                                    },
                                                };
                                            });
                                        }
                                    }
                                    setIsEditing(false);
                                    setIsModalOpen(false);
                                }}
                            />
                        )}
                    </>
                )}
            </div>
        );
    }
);

export default AddGoalEvent;
